import React, { useState, useEffect } from "react";
import { Card, Form, Button, Row, Col, Table, Modal } from "react-bootstrap";
import Layout from "../../layout/Layout";
import "../../styles/StandardDocument.css";
import { useAuth } from "../../context/AuthContext";

import {
  getSignedUrl,
  putPinnedApi,
  uploadSharedDocument,
  updateSharedDocument,
  getSharedDocument,
} from "../../../api/DocumentApi/getGeneralApi";
import { createDocumentHandleChange } from "../../helper/createDocumentHandleChange";
import { eksikAlanlar, yuklemeHataMesaji } from "../../../utils/yuklemeHata";

function SharedHumanResourcesDocument() {
  const { user } = useAuth();
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [feedback, setFeedback] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const [newDoc, setNewDoc] = useState({
    category: "insanKaynaklari",
    title: "",
    description: "",
    file: null,
    reminderActive: false,
    startDate: "",
    endDate: "",
    note: "",
    notifyBefore: "",
    responseblePersonel: [],
  });
  const [editingDoc, setEditingDoc] = useState(null);
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await getSharedDocument("insanKaynaklari");
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }
      } catch (err) {
        console.error("Belgeler çekilemedi:", err);
      }
    };
    fetchDocs();
  }, []);

  const filteredDocs = docs.filter(
    (d) =>
      d.title.toLowerCase().includes(search.toLowerCase()) ||
      d.description?.toLowerCase().includes(search.toLowerCase())
  );

  const handleOpenDocument = async (type, id) => {
    try {
      const res = await getSignedUrl(type, id);
      if (res.data.url) {
        window.open(res.data.url, "_blank");
      }
    } catch (err) {
      console.error("Signed URL alınamadı:", err);
    }
  };

  const handlePinnedDocument = async (type, id) => {
    try {
      const res = await putPinnedApi(type, id);

      if (res.data.success) {
        setDocs((prevDocs) =>
          prevDocs.map((doc) =>
            doc._id === id ? { ...doc, pinned: !doc.pinned } : doc
          )
        );
      }
    } catch (err) {
      console.error("Pinned toggle edilemedi:", err);
    }
  };

  // ---------------- Yeni Ekle ----------------
  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setNewDoc({
      category: "insanKaynaklari",
      title: "",
      description: "",
      file: null,
    });
  };

  // ---------------- Düzenleme ----------------
  const handleShowEdit = (doc) => {

    setEditingDoc(doc);

    setNewDoc({
      category: "insanKaynaklari",
      title: doc.title || "",
      description: doc.description || "",
      file: null,
      reminderActive:
        doc.reminderStatus === true || doc.reminderStatus === "true",
      startDate: doc.reminder?.startDate
        ? doc.reminder.startDate.slice(0, 10)
        : "",
      endDate: doc.reminder?.endDate ? doc.reminder.endDate.slice(0, 10) : "",
      note: doc.reminder?.note || "",
      notifyBefore: doc.reminder?.notifyBefore || "",
    });

    setShowEditModal(true);
  };

  const handleCloseEdit = () => {
    setShowEditModal(false);
    setEditingDoc(null);
    setNewDoc({
      category: "insanKaynaklari",
      title: "",
      description: "",
      file: null,
    });
  };

  // ---------------- Input change ----------------
const handleChange = createDocumentHandleChange({
  setNewDoc,
  getIsEditMode: () => Boolean(editingDoc?._id),
});

  const validateDoc = (doc) => {
    if (!doc.title?.trim()) return "Başlık boş olamaz!";
    if (!doc.description?.trim()) return "Açıklama boş olamaz!";
    if (!doc.file) return "Bir dosya yüklemelisiniz!";

    if (doc.reminderActive) {
      if (!doc.startDate || !doc.endDate) {
        return "Başlangıç ve bitiş tarihleri seçilmeli!";
      }
      if (!doc.notifyBefore || Number(doc.notifyBefore) <= 0) {
        return "Bildirim günü 0'dan büyük olmalı!";
      }
    }

    return null; //  her şey yolunda
  };

  const handleSave = async () => {
    if (!user) {
      alert("Önce giriş yapmalısınız!");
      return;
    }
    const eksik = eksikAlanlar(newDoc);
    if (eksik) {
      setFeedback({ show: true, type: "error", message: eksik });
      return;
    }

    //  Validation check
    const error = validateDoc(newDoc);
    if (error) {
      setFeedback({ show: true, type: "danger", message: error });
      return;
    }

    try {
      const reminderData = newDoc.reminderActive
        ? {
            reminderActive: true,
            startDate: newDoc.startDate,
            endDate: newDoc.endDate,
            note: newDoc.note,
            notifyBefore: newDoc.notifyBefore || 30,
          }
        : null;

      const result = await uploadSharedDocument(
        newDoc.category,
        user._id || user.id,
        newDoc.file,
        newDoc.title,
        newDoc.description,
        reminderData
      );
      if (result.data.statusCode === 200) {
        const res = await getSharedDocument("insanKaynaklari");
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }

        handleClose();
        setNewDoc({
          category: "insanKaynaklari",
          title: "",
          description: "",
          file: null,
          reminderActive: false,
          startDate: "",
          endDate: "",
          note: "",
          notifyBefore: "",
        });

        setFeedback({
          show: true,
          type: "success",
          message: "Dosya başarıyla yüklendi ",
        });
      } else {
        setFeedback({
          show: true,
          type: "danger",
          message: "Yükleme başarısız oldu!",
        });
      }
    } catch (err) {
      console.error(err);
      setFeedback({ show: true, type: "danger", message: yuklemeHataMesaji(err) });
    }
  };

  const handleEditSave = async () => {
    if (!user || !editingDoc) {
      alert("Önce giriş yapmalısınız!");
      return;
    }
    const eksik = eksikAlanlar(newDoc, { dosyaZorunlu: false });
    if (eksik) {
      setFeedback({ show: true, type: "error", message: eksik });
      return;
    }
    try {
      const reminderData = newDoc.reminderActive
        ? {
            reminderActive: true,
            startDate: newDoc.startDate,
            endDate: newDoc.endDate,
            note: newDoc.note,
            notifyBefore: newDoc.notifyBefore || 30,
          }
        : null;

      const result = await updateSharedDocument(
        newDoc.category,
        editingDoc._id,
        user.id || user._id,
        newDoc.file,
        newDoc.title,
        newDoc.description,
        reminderData
      );

      if (result.data.statusCode === 200) {
        const res = await getSharedDocument("insanKaynaklari");
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }
        handleCloseEdit();
        setFeedback({
          show: true,
          type: "success",
          message: "Dosya başarıyla güncellendi ",
        });
      } else {
        setFeedback({
          show: true,
          type: "error",
          message: "Güncelleme başarısız oldu!",
        });
      }
    } catch (err) {
      console.error(err);
      setFeedback({ show: true, type: "error", message: yuklemeHataMesaji(err) });
    }
  };

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Ortak Döküman Girişi</h2>
      <Card className="p-3 mb-4 shadow-sm border-0">
        <Row className="align-items-center g-3">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" onClick={handleShow}>
              Yeni Ekle
            </Button>
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm border-0">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th>Sabitle</th>
              <th>Başlık</th>
              <th>Açıklama</th>
              <th>Yükleyen Kişi</th>
              <th>Döküman</th>
              <th>Hatırlatıcı</th>
              <th>Durum</th>
              <th>Hatırlamaya Kalan Süre</th>
              <th>Yüklenme Tarihi</th>
              {user?.permissions.includes("insanKaynaklari_shared_update") && (
                <th>Düzenle</th>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredDocs.length > 0 ? (
              filteredDocs.map((d) => {
                let statusText = "Aktif değil";
                let dotColor = "white";
                let daysText = "—";
                let dotBlink = false;

                if (d.reminder) {
                  const daysLeft = d.reminder.daysLeft;
                  const notifyBefore = d.reminder.notifyBefore;

                  if (daysLeft <= 0) {
                    statusText = "Aktif";
                    dotColor = "red";
                    daysText = "Süre doldu!";
                    dotBlink = true;
                  } else if (daysLeft <= notifyBefore) {
                    statusText = "Aktif";
                    dotColor = "orange";
                    daysText = `${daysLeft} gün kaldı`;
                    dotBlink = true;
                  } else {
                    statusText = "Aktif";
                    dotColor = "green";
                    daysText = `${daysLeft} gün kaldı`;
                    dotBlink = false;
                  }
                }

                return (
                  <tr key={d._id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={d.pinned || false}
                        onChange={() => handlePinnedDocument("shared", d._id)}
                      />
                    </td>

                    <td>{d.title}</td>
                    <td>{d.description}</td>
                    <td>
                      {d.personelId
                        ? `${d.personelId.name || ""} ${
                            d.personelId.surname || ""
                          }`.trim()
                        : "Bulunamadı"}
                    </td>
                    <td>
                      <Button
                        variant="link"
                        onClick={() => handleOpenDocument("shared", d._id)}
                      >
                        Dökümana Git
                      </Button>
                    </td>
                    <td>{statusText}</td>
                    <td>
                      <span
                        className={`dot ${dotBlink ? "blink" : ""}`}
                        style={{ backgroundColor: dotColor }}
                      ></span>
                    </td>
                    <td>{daysText}</td>
                    <td>{new Date(d.createdAt).toLocaleString("tr-TR")}</td>
                    {user?.permissions.includes(
                      "insanKaynaklari_shared_update"
                    ) && (
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="me-2"
                          onClick={() => handleShowEdit(d)}
                        >
                          Düzenle
                        </Button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={
                    user?.permissions.includes("insanKaynaklari_shared_update")
                      ? "10"
                      : "9"
                  }
                  className="text-center text-muted py-4"
                >
                  Kayıt bulunamadı
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Yeni Ortak Döküman Ekle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Başlık */}
            <Form.Group className="mb-3">
              <Form.Label>Başlık</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={newDoc.title}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Açıklama */}
            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={newDoc.description}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Dosya */}
            <Form.Group className="mb-3">
              <Form.Label>Dosya Yükle</Form.Label>
              <Form.Control type="file" name="file" onChange={handleChange} />
            </Form.Group>
          </Form>

          <Form.Check
            type="switch"
            id="reminderActiveSwitch"
            label="Hatırlatma Aktif"
            name="reminderActive"
            checked={newDoc.reminderActive || false}
            onChange={handleChange}
          />

          {newDoc.reminderActive && (
            <>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Başlangıç Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={newDoc.startDate || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bitiş Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={newDoc.endDate || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Not</Form.Label>
                <Form.Control
                  type="text"
                  name="note"
                  value={newDoc.note || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bildirime Kaç Gün Kala</Form.Label>
                <Form.Control
                  type="number"
                  name="notifyBefore"
                  value={newDoc.notifyBefore || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Kaydet
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Düzenleme Modalı */}
      <Modal show={showEditModal} onHide={handleCloseEdit} centered>
        <Modal.Header closeButton>
          <Modal.Title>Döküman Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Başlık */}
            <Form.Group className="mb-3">
              <Form.Label>Başlık</Form.Label>
              <Form.Control
                type="text"
                name="title"
                value={newDoc.title}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Açıklama */}
            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={newDoc.description}
                onChange={handleChange}
              />
            </Form.Group>

            {/* Mevcut dosya linki */}
            {false && editingDoc?.fileName && (
              <div className="mb-3">
                <a
                  href={`http://localhost:3001/${editingDoc.fileName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  📂 Mevcut dosyayı görüntüle
                </a>
              </div>
            )}

            {/* Yeni dosya yükle */}
            <Form.Group className="mb-3">
              <Form.Label>Yeni Dosya Yükle</Form.Label>
              <Form.Control type="file" name="file" onChange={handleChange} />
            </Form.Group>
          </Form>

          {/*  Reminder Switch */}
          <Form.Check
            type="switch"
            id="editReminderActiveSwitch"
            label="Hatırlatma Aktif"
            name="reminderActive"
            checked={newDoc.reminderActive || false}
            onChange={handleChange}
          />

          {/*  Reminder Alanları */}
          {newDoc.reminderActive && (
            <>
              <Form.Group className="mb-3 mt-3">
                <Form.Label>Başlangıç Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={newDoc.startDate || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bitiş Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={newDoc.endDate || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Not</Form.Label>
                <Form.Control
                  type="text"
                  name="note"
                  value={newDoc.note || ""}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Bildirime Kaç Gün Kala</Form.Label>
                <Form.Control
                  type="number"
                  name="notifyBefore"
                  value={newDoc.notifyBefore || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>
            İptal
          </Button>
          <Button variant="primary" onClick={handleEditSave}>
            Güncelle
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Feedback Modal */}
      <Modal
        show={feedback.show}
        onHide={() => setFeedback({ ...feedback, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {feedback.type === "success" ? "Başarılı" : "Hata"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{feedback.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setFeedback({ ...feedback, show: false })}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default SharedHumanResourcesDocument;
